export const PASSIVE = {passive: true};

export const ROUND_ARROW =
  '<svg width="16" height="6" xmlns="http://www.w3.org/2000/svg"><path d="M0 6s1.796-.013 4.67-3.615C5.851.9 6.93.006 8 0c1.07-.006 2.148.887 3.343 2.385C14.233 6.005 16 6 16 6H0z"></svg>';

export const IOS_CLASS = `__NAMESPACE_PREFIX__-iOS`;
export const BOX_CLASS = `__NAMESPACE_PREFIX__-box`;
export const CONTENT_CLASS = `__NAMESPACE_PREFIX__-content`;
export const BACKDROP_CLASS = `__NAMESPACE_PREFIX__-backdrop`;
export const ARROW_CLASS = `__NAMESPACE_PREFIX__-arrow`;
export const SVG_ARROW_CLASS = `__NAMESPACE_PREFIX__-svg-arrow`;
